export default __webpack_public_path__ + "img/app-page/screen1_us.f84787bc7db4f3cd1734330bea2ddb29.png";